import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { FontSizes, FontWeights } from '../../../../types/common/types';

export const templateAccountDetails = document.createElement('template');

templateAccountDetails.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div id="details-section">
    <gz-title fontSize="18" class="subsection-title" fontWeight="${FontWeights.MEDIUM}" id="details-section-title"></gz-title>

    <gz-form-field id="import-from-active-directory" class="hidden">
      <gz-toggle gz-form-input id="import-from-active-directory-toggle" checked></gz-toggle>
      <gz-button id="ad-synchronize-button" type="full" buttonHeight="small"></gz-button>
      <gz-text fontSize="${FontSizes.PARAGRAPH_13}" id="import-from-active-directory-description"></gz-text>
      <gz-input-error inputWidth="240"></gz-input-error>
    </gz-form-field>

    <gz-form-field id="user-id" label="" class="hidden">
      <gz-input gz-form-input class="input-content" placeholder="" inputwidth="240"></gz-input>
      <gz-input-error inputWidth="240"></gz-input-error>
    </gz-form-field>
    <gz-form-field id="username" class="details-input-form-field" label="" required>
      <gz-input gz-form-input class="input-content" placeholder="" inputwidth="240"></gz-input>
      <gz-input-error inputWidth="240"></gz-input-error>
    </gz-form-field>
    <gz-form-field id='username-ad-form-field' class="details-input-form-field hidden" label='' required>
      <gz-single-select-complex gz-form-input labelWidth='240'></gz-single-select-complex>
      <gz-input-error inputWidth="240"></gz-input-error>
    </gz-form-field>
    <gz-form-field id="email" class="details-input-form-field" label="" required>
      <gz-input gz-form-input class="input-content" placeholder="" inputwidth="240"></gz-input>
      <gz-input-error inputWidth="240"></gz-input-error>
    </gz-form-field>
    <gz-form-field id="fullname" class="details-input-form-field" label="" required>
      <gz-input gz-form-input class="input-content" placeholder="" inputwidth="240"></gz-input>
      <gz-input-error inputWidth="240"></gz-input-error>
    </gz-form-field>

    <gz-form-field id='account-company-form-field' class="details-input-form-field" label='' required>
          <gz-single-select-complex gz-form-input labelWidth='240'></gz-single-select-complex>
          <gz-input-error inputWidth="240"></gz-input-error>
    </gz-form-field>

    <gz-form-field id="password" class="details-input-form-field" label="" required>
      <gz-input gz-form-input type="password" class="input-content" placeholder="" inputwidth="240"></gz-input>
      <gz-input-error inputWidth="240"></gz-input-error>
    </gz-form-field>
    <gz-form-field id="confirm-password" class="details-input-form-field" label="" required>
      <gz-input gz-form-input type="password" class="input-content" placeholder="" inputwidth="240"></gz-input>
      <gz-input-error inputWidth="240"></gz-input-error>
      <gz-text fontSize="${FontSizes.PARAGRAPH_12}" id="confirm-password-description"></gz-text>
    </gz-form-field>
    <gz-form-field id="timezone" class="details-input-form-field" class="label-mw-80" label="" required>
      <gz-dropdown gz-form-input type="dropdown" id="timezone-dropdown" class="input-content" labelWidth="240"></gz-dropdown>
      <gz-input-error inputWidth="240"></gz-input-error>
    </gz-form-field>
    <gz-form-field id="language" class="details-input-form-field" label="" required>
      <gz-dropdown gz-form-input type="dropdown" id="language-dropdown" class="input-content" labelWidth="240"></gz-dropdown>
      <gz-input-error inputWidth="240"></gz-input-error>
    </gz-form-field>
    <gz-form-field  id="phone-number" class="details-input-form-field" label="">
      <gz-phone-input gz-form-input type="input-content" id="phone-number-input" class="input-content" labelWidth="240"></gz-phone-input>
      <gz-input-error></gz-input-error>
    </gz-form-field>
  </div>
`;
